import type {} from "@lit/react";
import { ProgressBar as ProgressBarElement, } from "@vaadin/progress-bar/vaadin-progress-bar.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ProgressBarElement, };
export type ProgressBarEventMap = Readonly<{}>;
const events = {} as ProgressBarEventMap;
export type ProgressBarProps = WebComponentProps<ProgressBarElement, ProgressBarEventMap>;
export const ProgressBar = createComponent({
    elementClass: ProgressBarElement, events, react: React, tagName: "vaadin-progress-bar"
});
